import styled, { css } from 'styled-components';

import { ReactComponent as WaveSVG } from 'Public/graphics/waves/hero-banner/wave-default-hero-grey-cropped.svg';

export const Wave = styled(WaveSVG)`
    ${({ theme }) => css`
        position: absolute;
        z-index: -1;
        transform: scale(1);
        top: -3rem;
        left: -39rem;

        @media ${theme.breakpoints.medium.media} {
            top: -3rem;
            left: -22rem;
        }

        @media ${theme.breakpoints.large.media} {
            transform: scale(1.5);
            top: 5rem;
            left: 6rem;
        }

        path {
            fill: #3d3d3d;
        }
    `}
`;

export const Wrapper = styled.div`
    ${({ theme }) => css`
        margin: 0;
        margin-bottom: 1.5rem;

        @media ${theme.breakpoints.large.media} {
            margin-bottom: 4rem;
        }
    `}
`;

export const ListingCardWrapper = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            height: 100%;
            padding-top: 2.875rem;
        }
    `}
`;
